import { useTranslation } from 'react-i18next';
import { Button } from '@sib/ui';

export interface ErrorHandlerProps {
  error?: Error | null;
  onErrorReset?: () => void;
}

const ErrorHandler = ({ error, onErrorReset }: ErrorHandlerProps) => {
  const { t } = useTranslation();

  return (
    <div className="p-3">
      <div className="border-destructive bg-destructive/10 flex items-end rounded-sm border-2 p-3">
        <div className="flex flex-[1_1] flex-col">
          <p className="text-destructive text-sm font-semibold">
            {t('components.errorBoundary.title')}
          </p>
          <p className="text-destructive text-xs">
            {error?.message || t('components.errorBoundary.defaultMessage')}
          </p>
        </div>
        {onErrorReset && (
          <Button
            className="text-destructive"
            variant="ghost"
            onClick={onErrorReset}
          >
            {t('components.errorBoundary.reset')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorHandler;
